var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5C1.72375 3.5 1.5 3.72375 1.5 4V5.55313C2.39687 5.86562 3.04 6.71875 3.04 7.72188C3.04 8.725 2.39687 9.57812 1.5 9.89063V11.4438C1.5 11.72 1.72375 11.9438 2 11.9438H16C16.2762 11.9438 16.5 11.72 16.5 11.4438V9.89063C15.6031 9.57812 14.96 8.725 14.96 7.72188C14.96 6.71875 15.6031 5.86562 16.5 5.55313V4C16.5 3.72375 16.2762 3.5 16 3.5H2ZM0 4C0 2.89531 0.895313 2 2 2H16C17.1047 2 18 2.89531 18 4V6.13125C18 6.42188 17.7906 6.66875 17.5031 6.71875C17.0344 6.80312 16.6781 7.22188 16.6781 7.72188C16.6781 8.22188 17.0344 8.64063 17.5031 8.725C17.7906 8.775 18 9.02188 18 9.3125V11.4438C18 12.5484 17.1047 13.4438 16 13.4438H2C0.895313 13.4438 0 12.5484 0 11.4438V9.3125C0 9.02188 0.209375 8.775 0.496875 8.725C0.965625 8.64063 1.32188 8.22188 1.32188 7.72188C1.32188 7.22188 0.965625 6.80312 0.496875 6.71875C0.209375 6.66875 0 6.42188 0 6.13125V4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6C5.5 5.72386 5.72386 5.5 6 5.5ZM12.5 6V9.5C12.5 9.77614 12.2761 10 12 10C11.7239 10 11.5 9.77614 11.5 9.5V6C11.5 5.72386 11.7239 5.5 12 5.5C12.2761 5.5 12.5 5.72386 12.5 6Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketRegular);
export default __webpack_public_path__ + "static/media/ticket-regular.3330e8695789f93bffa2f38b2d17b47f.svg";
export { ForwardRef as ReactComponent };